// These are functions I ripped from the old version.

export function badgeRanking(badges) {
  const badgeRank = [
    'first_class',
    'roadie_of_the_year',
    'king_of_the_road',
    'rockstar',
    'x_miler',
    'road_tripper',
    'rapid_roadie',
    'pet_pro',
    'huge_hauler',
    'around_towner',
    'extra_equipped',
    'waffle_lover',
  ]
  let sortedBadges = []

  // Remove xMilers & Roadie of the Year from badges and sort them independently.
  let xMilers = []
  let roadieOfTheYear = []

  for (let i = 0; i < badges.length; i++) {
    if (badges[i].type === 'x_miler') {
      xMilers.push(badges[i])
      badges.splice(i, 1)
      i--
    } else if (badges[i].type === 'roadie_of_the_year') {
      roadieOfTheYear.push(badges[i])
      badges.splice(i, 1)
      i--
    }
  }

  // Sort any xMilers and put only the highest ranked back in the badges array
  xMilers.sort(function (a, b) {
    return b.level - a.level
  })
  if (xMilers.length > 0) {
    badges.push(xMilers[0])
  }

  // Sort badges excluding Roadie of the year
  for (let j = 0; j < badgeRank.length; j++) {
    let badge = badges.find((badge) => badge.type === badgeRank[j])

    if (badge) {
      sortedBadges.push(badge)
    }
  }

  // Sort Roadie of the Year by year
  roadieOfTheYear.sort(function (a, b) {
    return b.level - a.level
  })

  // If we have Roadie of the Year badges then put them in the proper spot in the
  // sorted badges array

  if (roadieOfTheYear.length > 0) {
    if (sortedBadges[0].type === 'first_class') {
      sortedBadges.splice(1, 0, ...roadieOfTheYear)
    } else {
      sortedBadges.splice(0, 0, ...roadieOfTheYear)
    }
  }

  return sortedBadges
}
